module.exports = __webpack_public_path__ + "static/media/03_Maf_NuestroEquipo_JuanNinoTej.1fe0a063.png";